import {IAggregationFunction} from "@ispm/dynamic-form/interfaces/IAggregationFunction.interface";
import {EventDataFilterService} from "@ispm/shared/services/event-data-filter.service";

export class CountAggregationFunction implements IAggregationFunction {

  private eventFilterService: EventDataFilterService = new EventDataFilterService();

  performAggregation(inputData: Array<any>, hasFilter: boolean, filterExpression: Object): number {
    let filteredData: Array<any> = this.eventFilterService.filterDataWithExpression(inputData, hasFilter, filterExpression);
    if(Array.isArray(filteredData)){
      return filteredData.length;
    }
    return 0;
  }

}
